// extracted by mini-css-extract-plugin
export default {"info":"btgMDbKD","title":"AE4rc5qW","list":"VZNplydM","listItem":"VQ5y1joM","error":"Vgpencj7","valid":"ZNx1CE9E","icon":"Is3TiFra"};